// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "microsite".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "microsite" table (1:1 with a DB row, on the wire). */
export const micrositeAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    slug: z.string(),
    status: z.string(),
    theme: z.unknown(),
    publishedRevisionId: z.string().nullable(),
    draftRevisionId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=microsite.js.map